import { getCustomerTiers } from "../../../../app/api/getCustomerTiers";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { ILoyaltyTier } from "../../../../Orchestrator/Types/Interface/ICustomerTiers";

export class GetCustomerTiersAction extends BaseAction<ILoyaltyTier[], void> {
  override async run(): Promise<ILoyaltyTier[] | null> {
    let customerTiersData: ILoyaltyTier[] = [];

    try {
      const response: any = await getCustomerTiers();

      if (response?.status === "ok" && Array.isArray(response.answer)) {
        customerTiersData = response.answer as ILoyaltyTier[];
        updateRecoilState("customerTiersDataAtom", customerTiersData);
      } else {
        console.warn("Unexpected API response:", response);
      }
    } catch (error) {
      console.error("Error fetching customer tiers:", error);
    }

    return customerTiersData.length > 0 ? customerTiersData : null;
  }
}

export const getCustomerTiersAction = new GetCustomerTiersAction();
